import React, { Suspense } from "react"
import { Box } from "@mui/material"
import { getMaterialIconComponent } from "../../containers/Organizations/enterprise/EnterpriseLogoIconPicker"
import { generateCloudinaryDownloadUrl } from "../../utils/cloudinary"
import { COLORS } from "../../utils"

const getInitials = (name = "") => {
  const words = name.trim().split(/\s+/)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

const sx = {
  tile: {
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",
  },
  image: { width: "100%", height: "100%", objectFit: "contain" },
}

const EnterpriseBadge = ({ enterprise, size = 32 }) => {
  const { name, logo, color } = enterprise || {}
  const hasIcon = !!(logo && logo.icon)
  const IconComponent = hasIcon ? getMaterialIconComponent(logo.icon) : null
  const logoUrl = !hasIcon && logo && logo.publicId ? generateCloudinaryDownloadUrl(logo.publicId) : null

  if (hasIcon) {
    return (
      <Box sx={{ ...sx.tile, width: size, height: size, bgcolor: COLORS.GREY_RECIPE_BACKGROUND }}>
        <Suspense fallback={null}>
          <IconComponent sx={{ color: color || COLORS.LABEL_GREY, fontSize: size * 0.6 }} />
        </Suspense>
      </Box>
    )
  }

  if (logoUrl) {
    return (
      <Box sx={{ ...sx.tile, width: size, height: size, bgcolor: COLORS.WHITE }}>
        <Box component="img" src={logoUrl} alt={`Logo ${name}`} sx={sx.image} />
      </Box>
    )
  }

  return (
    <Box sx={{
      ...sx.tile, width: size, height: size,
      bgcolor: color || COLORS.GREY_RECIPE_BACKGROUND,
      color: color ? COLORS.WHITE : COLORS.LABEL_GREY,
      fontSize: size * 0.35, fontWeight: 700,
    }}>
      {getInitials(name)}
    </Box>
  )
}

export default EnterpriseBadge
